// Modules
import { reduxForm, Field } from 'redux-form';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { TextInput, TextAreaInput } from 'components/forms/form-elements';
import { Form } from 'components/forms/form-structure';
import { handleServerError } from 'utils/form-utils';
import requiredValidation from 'utils/required-validation';
import { TeamSelect } from 'components/forms/selects';

// Component
function MfaDeviceForm(props) {
  return (
    <Form preventAutoFocus onSubmit={props.handleSubmit} {..._.pick(props, ['submitting', 'error', 'submitFailed'])}>
      <Field component={TextInput} name="name" label="Name" />
      <Field component={TextInput} name="host" label="Host" />
      <Field component={TeamSelect} name="team" label="Team" />
      <Field component={TextAreaInput} name="description" label="Description" />
    </Form>
  );
}

MfaDeviceForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object
};

export default reduxForm({
  form: 'mfa-device-form',
  validate: (values) => requiredValidation(['name', 'host'], values),
  onSubmitFail: handleServerError
})(MfaDeviceForm);

